// import { database, ref, onValue, set, auth } from '../firebase';

// class GlobalSyncService {
//   constructor() {
//     this.activeListeners = new Map();
//     this.currentUser = null;
//     this.isInitialized = false;
//     this.syncInProgress = false;

//     // Data structure paths that need to be synced
//     this.SYNC_PATHS = [
//       'products',
//       'categories',
//       'brands',
//       'customers',
//       'invoices',
//       'suppliers',
//       'inventory',
//       'reports',
//       'settings',
//       'companyInfo',
//       'taxSettings',
//       'paymentMethods',
//       'discountSettings',
//       'sales',
//       'receipts',
//       'transactions',
//       'purchaseReturns',
//       'salesReturns',
//       'stockEntries',
//       'openingStock',
//       'partners',
//       'paymentModes',
//       'productGroups',
//       'gstTaxes',
//       'groups',
//       'customUnits',
//       'units',
//       'branchProfiles',
//     ];

//     // Initialize auth listener immediately
//     this.initAuthListener();
//   }

//   initAuthListener() {
//     console.log('🔐 Initializing Global Sync Service Auth Listener...');

//     auth.onAuthStateChanged((user) => {
//       if (user && (!this.currentUser || user.email !== this.currentUser?.email)) {
//         console.log(`👤 User authenticated: ${user.email}`);
//         this.currentUser = user;
//         this.isInitialized = false; // Reset initialization flag

//         // Cleanup existing listeners before setting up new ones
//         this.cleanupListeners();

//         // Small delay to ensure Firebase auth is fully loaded
//         setTimeout(() => {
//           this.initializeGlobalSync();
//         }, 1000); // Increased delay for better stability
//       } else if (!user) {
//         console.log('👤 User logged out - cleaning up sync listeners');
//         this.currentUser = null;
//         this.cleanupListeners();
//         this.isInitialized = false;
//       }
//     });
//   }

//   async getEmployeePermissions(employeeEmail) {
//     const employeeKey = employeeEmail.replace(/\./g, '_');
//     const rightsRef = ref(database, `employeeRights/${employeeKey}`);
//     return new Promise((resolve) => {
//       onValue(
//         rightsRef,
//         (snapshot) => {
//           const data = snapshot.val();
//           resolve(data?.allowedMenus || {});
//         },
//         {
//           onlyOnce: true,
//           errorCallback: (error) => {
//             console.error(`Error fetching permissions for ${employeeEmail}:`, error);
//             resolve({});
//           },
//         }
//       );
//     });
//   }

//   mapMenuPathToDataPath(menuPath) {
//     // Map menu paths to corresponding data paths
//     const pathMap = {
//       '/dashboard/product': ['products'],
//       '/dashboard/group-table': ['productGroups', 'groups'],
//       '/dashboard/category-table': ['categories'],
//       '/dashboard/brand-table': ['brands'],
//       '/dashboard/unit-table': ['units', 'customUnits'],
//       '/dashboard/gst-tax': ['gstTaxes', 'taxSettings'],
//       '/dashboard/tax': ['taxSettings'],
//       '/dashboard/payment-modes': ['paymentModes', 'paymentMethods'],
//       '/dashboard/payables': ['transactions'],
//       '/dashboard/receivables': ['transactions', 'receipts'],
//       '/dashboard/suppliers': ['suppliers'],
//       '/dashboard/customers': ['customers'],
//       '/dashboard/partners': ['partners'],
//       '/dashboard/purchase-invoice': ['invoices'],
//       '/dashboard/purchase-return': ['purchaseReturns'],
//       '/dashboard/barcode-generator': ['products'],
//       '/dashboard/salesform': ['sales'],
//       '/dashboard/salesReturn': ['salesReturns'],
//       '/dashboard/purchase-report': ['reports'],
//       '/dashboard/purchase-return-report': ['reports', 'purchaseReturns'],
//       '/dashboard/sales-report': ['reports', 'sales'],
//       '/dashboard/sales-return-report': ['reports', 'salesReturns'],
//       '/dashboard/product-profit-report': ['reports'],
//       '/dashboard/accounts-report/supplier-payment': ['reports', 'transactions'],
//       '/dashboard/accounts-report/customer-receipt': ['reports', 'receipts'],
//       '/dashboard/accounts-report/customer-outstanding': ['reports', 'transactions'],
//       '/dashboard/accounts-report/purchase-outstanding': ['reports', 'transactions'],
//       '/dashboard/product-list-report': ['reports', 'products'],
//       '/dashboard/sales-revenue-report/top-selling': ['reports', 'sales'],
//       '/dashboard/sales-revenue-report/non-selling': ['reports', 'sales'],
//       '/dashboard/best-rate-finder': ['reports'],
//       '/dashboard/purchase-annexure-1a': ['reports'],
//       '/dashboard/purchase-annexure-1a/supplierwise': ['reports', 'suppliers'],
//       '/dashboard/purchase-annexure-1a/productwise': ['reports', 'products'],
//       '/dashboard/purchase-return-annexure-2a': ['reports', 'purchaseReturns'],
//       '/dashboard/purchase-return-annexure-2a/supplierwiseReturn': ['reports', 'suppliers'],
//       '/dashboard/purchase-return-annexure-2a/productwiseReturn': ['reports', 'products'],
//       '/dashboard/sales-annexure-1a': ['reports', 'sales'],
//       '/dashboard/sales-annexure-1a/customerwise': ['reports', 'customers'],
//       '/dashboard/sales-annexure-1a/productwise': ['reports', 'products'],
//       '/dashboard/sales-return-annexure-2a': ['reports', 'salesReturns'],
//       '/dashboard/sales-return-annexure-2a/customerwiseReturn': ['reports', 'customers'],
//       '/dashboard/sales-return-annexure-2a/productwiseReturn': ['reports', 'products'],
//       '/dashboard/branch-profile': ['branchProfiles'],
//     };
//     return pathMap[menuPath] || [];
//   }

//   getAllowedDataPaths(allowedMenus) {
//     const allowedPaths = new Set();
//     Object.values(allowedMenus).flat().forEach((menuPath) => {
//       const dataPaths = this.mapMenuPathToDataPath(menuPath);
//       dataPaths.forEach((path) => allowedPaths.add(path));
//     });
//     return Array.from(allowedPaths).filter((path) => this.SYNC_PATHS.includes(path));
//   }

//   async initializeGlobalSync() {
//     if (!this.currentUser || this.isInitialized || this.syncInProgress) {
//       return;
//     }

//     try {
//       this.syncInProgress = true;
//       console.log(`🌐 Initializing Global Auto-Sync Service for ${this.currentUser.email}...`);

//       // Check if current user is admin or employee
//       const userKey = this.currentUser.email.replace(/\./g, '_');
//       const profileRef = ref(database, `users/${userKey}/profile`);

//       return new Promise((resolve) => {
//         // Declare unsubscribe variable first
//         let unsubscribe;
        
//         unsubscribe = onValue(
//           profileRef,
//           async (snapshot) => {
//             try {
//               const profileData = snapshot.val();

//               if (profileData && profileData.isEmployee && profileData.adminEmail) {
//                 // Current user is an employee - set up sync with admin
//                 console.log(`👤 Employee detected - setting up sync with admin: ${profileData.adminEmail}`);
//                 const allowedMenus = await this.getEmployeePermissions(this.currentUser.email);
//                 const allowedDataPaths = this.getAllowedDataPaths(allowedMenus);
//                 await this.setupEmployeeSync(profileData.adminEmail, allowedDataPaths);
//               } else {
//                 // Current user is admin - set up sync with all employees
//                 console.log(`👑 Admin detected - setting up sync with all employees`);
//                 await this.setupAdminSync();
//               }

//               this.isInitialized = true;
//               this.syncInProgress = false;
//               console.log('✅ Global Auto-Sync Service fully initialized');

//               // Unsubscribe from profile listener after initial setup
//               if (unsubscribe) {
//                 unsubscribe();
//               }
//               resolve();
//             } catch (error) {
//               console.error('❌ Error in profile listener:', error);
//               this.syncInProgress = false;
//               if (unsubscribe) {
//                 unsubscribe();
//               }
//               resolve();
//             }
//           },
//           { onlyOnce: true }
//         );
//       });
//     } catch (error) {
//       console.error('❌ Error initializing global sync:', error);
//       this.syncInProgress = false;
//     }
//   }

//   async setupAdminSync() {
//     const adminEmail = this.currentUser.email;
//     const employeeEmails = await this.getEmployeeEmails(adminEmail);

//     if (employeeEmails.length > 0) {
//       console.log(`🔄 Setting up admin sync for ${employeeEmails.length} employees:`, employeeEmails);
//       await this.setupRealTimeSync(adminEmail, employeeEmails);
//     } else {
//       console.log('📝 No employees found for admin - sync ready for when employees are added');
//     }
//   }

//   async setupEmployeeSync(adminEmail, allowedDataPaths) {
//     const employeeEmails = await this.getEmployeeEmails(adminEmail);
//     console.log(`👤 Setting up employee sync with admin: ${adminEmail} and ${employeeEmails.length} other employees`);
//     await this.setupRealTimeSync(adminEmail, employeeEmails, allowedDataPaths);
//   }

//   async getEmployeeEmails(adminEmail) {
//     const adminEmailKey = adminEmail.replace(/\./g, '_');
//     const employeesRef = ref(database, `users/${adminEmailKey}/employees`);

//     return new Promise((resolve) => {
//       const unsubscribe = onValue(
//         employeesRef,
//         (snapshot) => {
//           const data = snapshot.val();
//           const employeeEmails = [];

//           if (data) {
//             Object.values(data).forEach((employee) => {
//               if (employee.email && employee.active !== false) {
//                 employeeEmails.push(employee.email);
//               }
//             });
//           }

//           console.log(`📋 Found ${employeeEmails.length} active employees for ${adminEmail}`);
//           unsubscribe();
//           resolve(employeeEmails);
//         },
//         {
//           onlyOnce: true,
//           errorCallback: (error) => {
//             console.error('Error fetching employee emails:', error);
//             unsubscribe();
//             resolve([]);
//           },
//         }
//       );
//     });
//   }

//   preventDuplicateListener(listenerKey, setupFunction) {
//     // Clean up existing listener if it exists
//     if (this.activeListeners.has(listenerKey)) {
//       const existingUnsubscribe = this.activeListeners.get(listenerKey);
//       if (typeof existingUnsubscribe === 'function') {
//         existingUnsubscribe();
//       }
//       this.activeListeners.delete(listenerKey);
//     }
    
//     // Set up new listener
//     const unsubscribe = setupFunction();
//     this.activeListeners.set(listenerKey, unsubscribe);
//   }

//   async setupRealTimeSync(adminEmail, employeeEmails, allowedDataPaths = this.SYNC_PATHS) {
//     // Clear existing listeners first to prevent duplicates
//     this.cleanupListeners();

//     const adminKey = adminEmail.replace(/\./g, '_');

//     console.log(
//       `🔄 Setting up real-time sync between admin (${adminEmail}) and employees (${employeeEmails.join(', ')}) for paths:`,
//       allowedDataPaths
//     );

//     // Set up listeners for admin data changes
//     allowedDataPaths.forEach((path) => {
//       const listenerKey = `admin-${path}`;
      
//       this.preventDuplicateListener(listenerKey, () => {
//         const adminPathRef = ref(database, `users/${adminKey}/${path}`);

//         return onValue(
//           adminPathRef,
//           async (snapshot) => {
//             // Add a small delay to prevent rapid fire updates
//             await new Promise((resolve) => setTimeout(resolve, 100));

//             if (snapshot.exists()) {
//               const data = snapshot.val();
//               const timestamp = new Date().toISOString();

//               console.log(`📤 Admin ${adminEmail} changed ${path} - syncing to ${employeeEmails.length} employees`);

//               // Sync to all employees with better error handling
//               const syncPromises = employeeEmails.map(async (employeeEmail) => {
//                 try {
//                   const employeeKey = employeeEmail.replace(/\./g, '_');
//                   const employeePermissions = await this.getEmployeePermissions(employeeEmail);
//                   const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

//                   if (!employeeAllowedPaths.includes(path)) {
//                     console.log(`⏭️ Skipping sync of ${path} for ${employeeEmail} - not in allowed paths`);
//                     return { success: true, employee: employeeEmail, skipped: true };
//                   }

//                   // Sync data to employee
//                   const employeePathRef = ref(database, `users/${employeeKey}/${path}`);
//                   await set(employeePathRef, data);

//                   // Update last sync timestamp
//                   const employeeSyncRef = ref(database, `users/${employeeKey}/syncMetadata/lastSyncAt`);
//                   await set(employeeSyncRef, timestamp);

//                   return { success: true, employee: employeeEmail };
//                 } catch (error) {
//                   console.error(`❌ Error syncing ${path} to ${employeeEmail}:`, error);
//                   return { success: false, employee: employeeEmail, error };
//                 }
//               });

//               const results = await Promise.allSettled(syncPromises);
//               const successful = results.filter((r) => r.status === 'fulfilled' && r.value.success && !r.value.skipped).length;

//               console.log(`✅ Successfully synced ${path} from admin to ${successful}/${employeeEmails.length} employees`);
//             }
//           },
//           {
//             errorCallback: (error) => {
//               console.error(`Error in admin listener for ${path}:`, error);
//               // Attempt to re-establish listener after error
//               setTimeout(() => {
//                 if (this.isInitialized && this.currentUser) {
//                   this.refreshSync();
//                 }
//               }, 5000);
//             },
//           }
//         );
//       });
//     });

//     // Set up listeners for each employee's data changes
//     for (const employeeEmail of employeeEmails) {
//       const employeeKey = employeeEmail.replace(/\./g, '_');
//       const employeePermissions = await this.getEmployeePermissions(employeeEmail);
//       const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

//       for (const path of allowedDataPaths) {
//         if (!employeeAllowedPaths.includes(path)) {
//           console.log(`⏭️ No listener set for ${path} for ${employeeEmail} - not in allowed paths`);
//           continue;
//         }

//         const listenerKey = `employee-${employeeEmail}-${path}`;
        
//         this.preventDuplicateListener(listenerKey, () => {
//           const employeePathRef = ref(database, `users/${employeeKey}/${path}`);

//           return onValue(
//             employeePathRef,
//             async (snapshot) => {
//               // Add a small delay to prevent rapid fire updates
//               await new Promise((resolve) => setTimeout(resolve, 100));

//               if (snapshot.exists()) {
//                 const data = snapshot.val();
//                 const timestamp = new Date().toISOString();

//                 console.log(
//                   `📤 Employee ${employeeEmail} changed ${path} - syncing to admin and ${employeeEmails.length - 1} other employees`
//                 );

//                 const syncPromises = [];

//                 // Sync back to admin
//                 syncPromises.push(
//                   (async () => {
//                     try {
//                       const adminPathRef = ref(database, `users/${adminKey}/${path}`);
//                       await set(adminPathRef, data);

//                       // Update admin sync timestamp
//                       const adminSyncRef = ref(database, `users/${adminKey}/syncMetadata/lastSyncAt`);
//                       await set(adminSyncRef, timestamp);

//                       return { success: true, target: 'admin', email: adminEmail };
//                     } catch (error) {
//                       console.error(`❌ Error syncing ${path} to admin ${adminEmail}:`, error);
//                       return { success: false, target: 'admin', email: adminEmail, error };
//                     }
//                   })()
//                 );

//                 // Sync to other employees
//                 employeeEmails.forEach((otherEmployeeEmail) => {
//                   if (otherEmployeeEmail !== employeeEmail) {
//                     syncPromises.push(
//                       (async () => {
//                         try {
//                           const otherEmployeePermissions = await this.getEmployeePermissions(otherEmployeeEmail);
//                           const otherEmployeeAllowedPaths = this.getAllowedDataPaths(otherEmployeePermissions);

//                           if (!otherEmployeeAllowedPaths.includes(path)) {
//                             console.log(`⏭️ Skipping sync of ${path} to ${otherEmployeeEmail} - not in allowed paths`);
//                             return { success: true, target: 'employee', email: otherEmployeeEmail, skipped: true };
//                           }

//                           const otherEmployeeKey = otherEmployeeEmail.replace(/\./g, '_');
//                           const otherEmployeePathRef = ref(database, `users/${otherEmployeeKey}/${path}`);
//                           await set(otherEmployeePathRef, data);

//                           // Update sync timestamp
//                           const otherSyncRef = ref(database, `users/${otherEmployeeKey}/syncMetadata/lastSyncAt`);
//                           await set(otherSyncRef, timestamp);

//                           return { success: true, target: 'employee', email: otherEmployeeEmail };
//                         } catch (error) {
//                           console.error(`❌ Error syncing ${path} to employee ${otherEmployeeEmail}:`, error);
//                           return { success: false, target: 'employee', email: otherEmployeeEmail, error };
//                         }
//                       })()
//                     );
//                   }
//                 });

//                 // Execute all sync operations
//                 const results = await Promise.allSettled(syncPromises);
//                 const successful = results.filter((r) => r.status === 'fulfilled' && r.value.success && !r.value.skipped).length;

//                 console.log(
//                   `✅ Employee sync completed: ${successful}/${results.length} successful for ${path} from ${employeeEmail}`
//                 );
//               }
//             },
//             {
//               errorCallback: (error) => {
//                 console.error(`Error in employee listener for ${employeeEmail} ${path}:`, error);
//                 // Attempt to re-establish listener after error
//                 setTimeout(() => {
//                   if (this.isInitialized && this.currentUser) {
//                     this.refreshSync();
//                   }
//                 }, 5000);
//               },
//             }
//           );
//         });
//       }
//     }

//     console.log(`🔄 Real-time bidirectional sync setup complete - ${this.activeListeners.size} listeners active`);

//     // Set up employee addition listener
//     this.setupEmployeeAdditionListener(adminEmail);
//   }

//   setupEmployeeAdditionListener(adminEmail) {
//     const adminKey = adminEmail.replace(/\./g, '_');
//     const employeesRef = ref(database, `users/${adminKey}/employees`);
    
//     // Check if listener already exists to prevent duplicate listeners
//     const listenerKey = 'employee-list-watcher';
//     if (this.activeListeners.has(listenerKey)) {
//       console.log('Employee addition listener already exists, skipping...');
//       return;
//     }

//     const unsubscribeEmployeesList = onValue(
//       employeesRef,
//       async (snapshot) => {
//         if (snapshot.exists()) {
//           const currentEmployees = [];
//           Object.values(snapshot.val()).forEach((employee) => {
//             if (employee.email && employee.active !== false) {
//               currentEmployees.push(employee.email);
//             }
//           });

//           // Check if we have new employees that weren't in our sync before
//           const existingEmployeeListeners = Array.from(this.activeListeners.keys())
//             .filter((key) => key.startsWith('employee-'))
//             .map((key) => key.split('-')[1]);

//           const newEmployees = currentEmployees.filter(
//             (email) => !existingEmployeeListeners.includes(email.replace(/\./g, '_'))
//           );

//           if (newEmployees.length > 0) {
//             console.log(`🆕 New employees detected: ${newEmployees.join(', ')} - refreshing sync`);
//             // Refresh sync to include new employees
//             setTimeout(() => {
//               this.refreshSync();
//             }, 1000);
//           }
//         }
//       },
//       {
//         errorCallback: (error) => {
//           console.error('Error in employee addition listener:', error);
//         },
//       }
//     );

//     this.activeListeners.set(listenerKey, unsubscribeEmployeesList);
//   }

//   cleanupListeners() {
//     console.log(`🧹 Cleaning up ${this.activeListeners.size} sync listeners`);

//     this.activeListeners.forEach((unsubscribe, key) => {
//       try {
//         if (typeof unsubscribe === 'function') {
//           unsubscribe();
//         }
//       } catch (error) {
//         console.error(`Error cleaning up listener ${key}:`, error);
//       }
//     });

//     this.activeListeners.clear();
//   }

//   async refreshSync() {
//     console.log('🔄 Manually refreshing global sync...');

//     // Don't refresh if already in progress
//     if (this.syncInProgress) {
//       console.log('Sync refresh already in progress, skipping...');
//       return;
//     }

//     this.cleanupListeners();
//     this.isInitialized = false;
//     this.syncInProgress = false;

//     // Small delay to prevent rapid refresh calls
//     setTimeout(async () => {
//       if (this.currentUser) {
//         await this.initializeGlobalSync();
//       }
//     }, 1000);
//   }

//   ensureSyncActive() {
//     if (this.currentUser && !this.isInitialized && !this.syncInProgress) {
//       console.log('🔄 Ensuring sync is active after navigation...');
//       setTimeout(() => {
//         this.initializeGlobalSync();
//       }, 1000);
//     }
//   }

//   getSyncStatus() {
//     return {
//       isInitialized: this.isInitialized,
//       currentUser: this.currentUser?.email || null,
//       activeListeners: this.activeListeners.size,
//       syncInProgress: this.syncInProgress,
//       syncPaths: this.SYNC_PATHS,
//     };
//   }

//   async forceSyncPath(path, data, sourceUserEmail) {
//     if (!this.SYNC_PATHS.includes(path)) {
//       console.warn(`Path ${path} is not in sync paths`);
//       return;
//     }

//     console.log(`🚀 Force syncing ${path} from ${sourceUserEmail}`);

//     try {
//       // Determine if source is admin or employee
//       const sourceKey = sourceUserEmail.replace(/\./g, '_');
//       const profileRef = ref(database, `users/${sourceKey}/profile`);

//       return new Promise((resolve) => {
//         let unsubscribe;
        
//         unsubscribe = onValue(
//           profileRef,
//           async (snapshot) => {
//             try {
//               const profileData = snapshot.val();

//               if (profileData && profileData.isEmployee && profileData.adminEmail) {
//                 // Source is employee - sync to admin and other employees
//                 const employeeEmails = await this.getEmployeeEmails(profileData.adminEmail);
//                 const adminKey = profileData.adminEmail.replace(/\./g, '_');

//                 // Sync to admin
//                 await set(ref(database, `users/${adminKey}/${path}`), data);

//                 // Sync to other employees with permission checks
//                 for (const employeeEmail of employeeEmails) {
//                   if (employeeEmail !== sourceUserEmail) {
//                     const employeePermissions = await this.getEmployeePermissions(employeeEmail);
//                     const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

//                     if (!employeeAllowedPaths.includes(path)) {
//                       console.log(`⏭️ Skipping force sync of ${path} to ${employeeEmail} - not in allowed paths`);
//                       continue;
//                     }

//                     const empKey = employeeEmail.replace(/\./g, '_');
//                     await set(ref(database, `users/${empKey}/${path}`), data);
//                   }
//                 }
//               } else {
//                 // Source is admin - sync to all employees
//                 const employeeEmails = await this.getEmployeeEmails(sourceUserEmail);

//                 for (const employeeEmail of employeeEmails) {
//                   const employeePermissions = await this.getEmployeePermissions(employeeEmail);
//                   const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

//                   if (!employeeAllowedPaths.includes(path)) {
//                     console.log(`⏭️ Skipping force sync of ${path} to ${employeeEmail} - not in allowed paths`);
//                     continue;
//                   }

//                   const empKey = employeeEmail.replace(/\./g, '_');
//                   await set(ref(database, `users/${empKey}/${path}`), data);
//                 }
//               }

//               console.log(`✅ Force sync completed for ${path}`);
              
//               if (unsubscribe) {
//                 unsubscribe();
//               }
//               resolve();
//             } catch (error) {
//               console.error(`❌ Error in force sync for ${path}:`, error);
//               if (unsubscribe) {
//                 unsubscribe();
//               }
//               throw error;
//             }
//           },
//           { onlyOnce: true }
//         );
//       });
//     } catch (error) {
//       console.error(`❌ Error in force sync for ${path}:`, error);
//       throw error;
//     }
//   }
// }

// // Create and export singleton instance
// const globalSyncService = new GlobalSyncService();

// // Optional: Add to window for debugging in development
// if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
//   window.globalSyncService = globalSyncService;
// }

// export default globalSyncService;
import { database, ref, onValue, set, auth } from '../firebase';

class GlobalSyncService {
  constructor() {
    this.activeListeners = new Map();
    this.currentUser = null;
    this.isInitialized = false;
    this.syncInProgress = false;

    // Data structure paths that need to be synced
    this.SYNC_PATHS = [
      'products',
      'categories',
      'brands',
      'customers',
      'invoices',
      'suppliers',
      'inventory',
      'reports',
      'settings',
      'companyInfo',
      'taxSettings',
      'paymentMethods',
      'discountSettings',
      'sales',
      'receipts',
      'transactions',
      'purchaseReturns',
      'salesReturns',
      'stockEntries',
      'openingStock',
      'partners',
      'paymentModes',
      'productGroups',
      'gstTaxes',
      'groups',
      'customUnits',
      'units',
      'branchProfiles',
    ];

    // Initialize auth listener immediately
    this.initAuthListener();
  }

  initAuthListener() {
    console.log('🔐 Initializing Global Sync Service Auth Listener...');

    auth.onAuthStateChanged((user) => {
      if (user && (!this.currentUser || user.email !== this.currentUser?.email)) {
        console.log(`👤 User authenticated: ${user.email}`);
        this.currentUser = user;
        this.isInitialized = false; // Reset initialization flag

        // Cleanup existing listeners before setting up new ones
        this.cleanupListeners();

        // Initialize sync immediately
        this.initializeGlobalSync();
      } else if (!user) {
        console.log('👤 User logged out - cleaning up sync listeners');
        this.currentUser = null;
        this.cleanupListeners();
        this.isInitialized = false;
      }
    });
  }

  async getEmployeePermissions(employeeEmail) {
    const employeeKey = employeeEmail.replace(/\./g, '_');
    const rightsRef = ref(database, `employeeRights/${employeeKey}`);
    return new Promise((resolve) => {
      onValue(
        rightsRef,
        (snapshot) => {
          const data = snapshot.val();
          resolve(data?.allowedMenus || {});
        },
        {
          onlyOnce: true,
          errorCallback: (error) => {
            console.error(`Error fetching permissions for ${employeeEmail}:`, error);
            resolve({});
          },
        }
      );
    });
  }

  mapMenuPathToDataPath(menuPath) {
    // Map menu paths to corresponding data paths
    const pathMap = {
      '/dashboard/product': ['products'],
      '/dashboard/group-table': ['productGroups', 'groups'],
      '/dashboard/category-table': ['categories'],
      '/dashboard/brand-table': ['brands'],
      '/dashboard/unit-table': ['units', 'customUnits'],
      '/dashboard/gst-tax': ['gstTaxes', 'taxSettings'],
      '/dashboard/tax': ['taxSettings'],
      '/dashboard/payment-modes': ['paymentModes', 'paymentMethods'],
      '/dashboard/payables': ['transactions'],
      '/dashboard/receivables': ['transactions', 'receipts'],
      '/dashboard/suppliers': ['suppliers'],
      '/dashboard/customers': ['customers'],
      '/dashboard/partners': ['partners'],
      '/dashboard/purchase-invoice': ['invoices'],
      '/dashboard/purchase-return': ['purchaseReturns'],
      '/dashboard/barcode-generator': ['products'],
      '/dashboard/salesform': ['sales'],
      '/dashboard/salesReturn': ['salesReturns'],
      '/dashboard/purchase-report': ['reports'],
      '/dashboard/purchase-return-report': ['reports', 'purchaseReturns'],
      '/dashboard/sales-report': ['reports', 'sales'],
      '/dashboard/sales-return-report': ['reports', 'salesReturns'],
      '/dashboard/product-profit-report': ['reports'],
      '/dashboard/accounts-report/supplier-payment': ['reports', 'transactions'],
      '/dashboard/accounts-report/customer-receipt': ['reports', 'receipts'],
      '/dashboard/accounts-report/customer-outstanding': ['reports', 'transactions'],
      '/dashboard/accounts-report/purchase-outstanding': ['reports', 'transactions'],
      '/dashboard/product-list-report': ['reports', 'products'],
      '/dashboard/sales-revenue-report/top-selling': ['reports', 'sales'],
      '/dashboard/sales-revenue-report/non-selling': ['reports', 'sales'],
      '/dashboard/best-rate-finder': ['reports'],
      '/dashboard/purchase-annexure-1a': ['reports'],
      '/dashboard/purchase-annexure-1a/supplierwise': ['reports', 'suppliers'],
      '/dashboard/purchase-annexure-1a/productwise': ['reports', 'products'],
      '/dashboard/purchase-return-annexure-2a': ['reports', 'purchaseReturns'],
      '/dashboard/purchase-return-annexure-2a/supplierwiseReturn': ['reports', 'suppliers'],
      '/dashboard/purchase-return-annexure-2a/productwiseReturn': ['reports', 'products'],
      '/dashboard/sales-annexure-1a': ['reports', 'sales'],
      '/dashboard/sales-annexure-1a/customerwise': ['reports', 'customers'],
      '/dashboard/sales-annexure-1a/productwise': ['reports', 'products'],
      '/dashboard/sales-return-annexure-2a': ['reports', 'salesReturns'],
      '/dashboard/sales-return-annexure-2a/customerwiseReturn': ['reports', 'customers'],
      '/dashboard/sales-return-annexure-2a/productwiseReturn': ['reports', 'products'],
      '/dashboard/branch-profile': ['branchProfiles'],
    };
    return pathMap[menuPath] || [];
  }

  getAllowedDataPaths(allowedMenus) {
    const allowedPaths = new Set();
    Object.values(allowedMenus).flat().forEach((menuPath) => {
      const dataPaths = this.mapMenuPathToDataPath(menuPath);
      dataPaths.forEach((path) => allowedPaths.add(path));
    });
    return Array.from(allowedPaths).filter((path) => this.SYNC_PATHS.includes(path));
  }

  async initializeGlobalSync() {
    if (!this.currentUser || this.isInitialized || this.syncInProgress) {
      return;
    }

    try {
      this.syncInProgress = true;
      console.log(`🌐 Initializing Global Auto-Sync Service for ${this.currentUser.email}...`);

      // Check if current user is admin or employee
      const userKey = this.currentUser.email.replace(/\./g, '_');
      const profileRef = ref(database, `users/${userKey}/profile`);

      return new Promise((resolve, reject) => {
        const unsubscribe = onValue(
          profileRef,
          async (snapshot) => {
            try {
              const profileData = snapshot.val();

              if (profileData && profileData.isEmployee && profileData.adminEmail) {
                console.log(`👤 Employee detected - setting up sync with admin: ${profileData.adminEmail}`);
                const allowedMenus = await this.getEmployeePermissions(this.currentUser.email);
                const allowedDataPaths = this.getAllowedDataPaths(allowedMenus);
                await this.setupEmployeeSync(profileData.adminEmail, allowedDataPaths);
              } else {
                console.log(`👑 Admin detected - setting up sync with all employees`);
                await this.setupAdminSync();
              }

              this.isInitialized = true;
              this.syncInProgress = false;
              console.log('✅ Global Auto-Sync Service fully initialized');

              unsubscribe(); // Clean up the listener
              resolve();
            } catch (error) {
              console.error('❌ Error in profile listener:', error);
              this.syncInProgress = false;
              unsubscribe(); // Ensure cleanup on error
              reject(error);
            }
          },
          {
            onlyOnce: true,
            errorCallback: (error) => {
              console.error('❌ Error in profile listener:', error);
              this.syncInProgress = false;
              unsubscribe(); // Ensure cleanup on error
              reject(error);
            },
          }
        );
      });
    } catch (error) {
      console.error('❌ Error initializing global sync:', error);
      this.syncInProgress = false;
      throw error;
    }
  }

  async setupAdminSync() {
    const adminEmail = this.currentUser.email;
    const employeeEmails = await this.getEmployeeEmails(adminEmail);

    if (employeeEmails.length > 0) {
      console.log(`🔄 Setting up admin sync for ${employeeEmails.length} employees:`, employeeEmails);
      await this.setupRealTimeSync(adminEmail, employeeEmails);
    } else {
      console.log('📝 No employees found for admin - sync ready for when employees are added');
    }
  }

  async setupEmployeeSync(adminEmail, allowedDataPaths) {
    const employeeEmails = await this.getEmployeeEmails(adminEmail);
    console.log(`👤 Setting up employee sync with admin: ${adminEmail} and ${employeeEmails.length} other employees`);
    await this.setupRealTimeSync(adminEmail, employeeEmails, allowedDataPaths);
  }

  async getEmployeeEmails(adminEmail) {
    const adminEmailKey = adminEmail.replace(/\./g, '_');
    const employeesRef = ref(database, `users/${adminEmailKey}/employees`);

    return new Promise((resolve) => {
      onValue(
        employeesRef,
        (snapshot) => {
          const data = snapshot.val();
          const employeeEmails = [];

          if (data) {
            Object.values(data).forEach((employee) => {
              if (employee.email && employee.active !== false) {
                employeeEmails.push(employee.email);
              }
            });
          }

          console.log(`📋 Found ${employeeEmails.length} active employees for ${adminEmail}`);
          resolve(employeeEmails);
        },
        {
          onlyOnce: true,
          errorCallback: (error) => {
            console.error('Error fetching employee emails:', error);
            resolve([]);
          },
        }
      );
    });
  }

  preventDuplicateListener(listenerKey, setupFunction) {
    if (this.activeListeners.has(listenerKey)) {
      const existingUnsubscribe = this.activeListeners.get(listenerKey);
      if (typeof existingUnsubscribe === 'function') {
        existingUnsubscribe();
      }
      this.activeListeners.delete(listenerKey);
    }

    const unsubscribe = setupFunction();
    if (typeof unsubscribe === 'function') {
      this.activeListeners.set(listenerKey, unsubscribe);
    }
    return unsubscribe;
  }

  async setupRealTimeSync(adminEmail, employeeEmails, allowedDataPaths = this.SYNC_PATHS) {
    this.cleanupListeners();

    const adminKey = adminEmail.replace(/\./g, '_');

    console.log(
      `🔄 Setting up real-time sync between admin (${adminEmail}) and employees (${employeeEmails.join(', ')}) for paths:`,
      allowedDataPaths
    );

    // Set up listeners for admin data changes
    allowedDataPaths.forEach((path) => {
      const listenerKey = `admin-${path}`;

      this.preventDuplicateListener(listenerKey, () => {
        const adminPathRef = ref(database, `users/${adminKey}/${path}`);

        return onValue(
          adminPathRef,
          async (snapshot) => {
            const data = snapshot.exists() ? snapshot.val() : null;
            const timestamp = new Date().toISOString();

            console.log(
              `📤 Admin ${adminEmail} ${snapshot.exists() ? 'changed' : 'deleted'} ${path} - syncing to ${employeeEmails.length} employees`
            );

            const syncPromises = employeeEmails.map(async (employeeEmail) => {
              try {
                const employeeKey = employeeEmail.replace(/\./g, '_');
                const employeePermissions = await this.getEmployeePermissions(employeeEmail);
                const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

                if (!employeeAllowedPaths.includes(path)) {
                  console.log(`⏭️ Skipping sync of ${path} for ${employeeEmail} - not in allowed paths`);
                  return { success: true, employee: employeeEmail, skipped: true };
                }

                const employeePathRef = ref(database, `users/${employeeKey}/${path}`);
                await set(employeePathRef, data);

                const employeeSyncRef = ref(database, `users/${employeeKey}/syncMetadata/lastSyncAt`);
                await set(employeeSyncRef, timestamp);

                return { success: true, employee: employeeEmail };
              } catch (error) {
                console.error(`❌ Error syncing ${path} to ${employeeEmail}:`, error);
                return { success: false, employee: employeeEmail, error };
              }
            });

            const results = await Promise.allSettled(syncPromises);
            const successful = results.filter((r) => r.status === 'fulfilled' && r.value.success && !r.value.skipped).length;

            console.log(`✅ Successfully synced ${path} from admin to ${successful}/${employeeEmails.length} employees`);
          },
          {
            errorCallback: (error) => {
              console.error(`Error in admin listener for ${path}:`, error);
              setTimeout(() => {
                if (this.isInitialized && this.currentUser) {
                  this.refreshSync();
                }
              }, 5000);
            },
          }
        );
      });
    });

    // Set up listeners for each employee's data changes
    for (const employeeEmail of employeeEmails) {
      const employeeKey = employeeEmail.replace(/\./g, '_');
      const employeePermissions = await this.getEmployeePermissions(employeeEmail);
      const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

      for (const path of allowedDataPaths) {
        if (!employeeAllowedPaths.includes(path)) {
          console.log(`⏭️ No listener set for ${path} for ${employeeEmail} - not in allowed paths`);
          continue;
        }

        const listenerKey = `employee-${employeeEmail}-${path}`;

        this.preventDuplicateListener(listenerKey, () => {
          const employeePathRef = ref(database, `users/${employeeKey}/${path}`);

          return onValue(
            employeePathRef,
            async (snapshot) => {
              const data = snapshot.exists() ? snapshot.val() : null;
              const timestamp = new Date().toISOString();

              console.log(
                `📤 Employee ${employeeEmail} ${snapshot.exists() ? 'changed' : 'deleted'} ${path} - syncing to admin and ${employeeEmails.length - 1} other employees`
              );

              const syncPromises = [];

              // Sync back to admin
              syncPromises.push(
                (async () => {
                  try {
                    const adminPathRef = ref(database, `users/${adminKey}/${path}`);
                    await set(adminPathRef, data);

                    const adminSyncRef = ref(database, `users/${adminKey}/syncMetadata/lastSyncAt`);
                    await set(adminSyncRef, timestamp);

                    return { success: true, target: 'admin', email: adminEmail };
                  } catch (error) {
                    console.error(`❌ Error syncing ${path} to admin ${adminEmail}:`, error);
                    return { success: false, target: 'admin', email: adminEmail, error };
                  }
                })()
              );

              // Sync to other employees
              employeeEmails.forEach((otherEmployeeEmail) => {
                if (otherEmployeeEmail !== employeeEmail) {
                  syncPromises.push(
                    (async () => {
                      try {
                        const otherEmployeePermissions = await this.getEmployeePermissions(otherEmployeeEmail);
                        const otherEmployeeAllowedPaths = this.getAllowedDataPaths(otherEmployeePermissions);

                        if (!otherEmployeeAllowedPaths.includes(path)) {
                          console.log(`⏭️ Skipping sync of ${path} to ${otherEmployeeEmail} - not in allowed paths`);
                          return { success: true, target: 'employee', email: otherEmployeeEmail, skipped: true };
                        }

                        const otherEmployeeKey = otherEmployeeEmail.replace(/\./g, '_');
                        const otherEmployeePathRef = ref(database, `users/${otherEmployeeKey}/${path}`);
                        await set(otherEmployeePathRef, data);

                        const otherSyncRef = ref(database, `users/${otherEmployeeKey}/syncMetadata/lastSyncAt`);
                        await set(otherSyncRef, timestamp);

                        return { success: true, target: 'employee', email: otherEmployeeEmail };
                      } catch (error) {
                        console.error(`❌ Error syncing ${path} to employee ${otherEmployeeEmail}:`, error);
                        return { success: false, target: 'employee', email: otherEmployeeEmail, error };
                      }
                    })()
                  );
                }
              });

              const results = await Promise.allSettled(syncPromises);
              const successful = results.filter((r) => r.status === 'fulfilled' && r.value.success && !r.value.skipped).length;

              console.log(
                `✅ Employee sync completed: ${successful}/${results.length} successful for ${path} from ${employeeEmail}`
              );
            },
            {
              errorCallback: (error) => {
                console.error(`Error in employee listener for ${employeeEmail} ${path}:`, error);
                setTimeout(() => {
                  if (this.isInitialized && this.currentUser) {
                    this.refreshSync();
                  }
                }, 5000);
              },
            }
          );
        });
      }
    }

    console.log(`🔄 Real-time bidirectional sync setup complete - ${this.activeListeners.size} listeners active`);

    this.setupEmployeeAdditionListener(adminEmail);
  }

  setupEmployeeAdditionListener(adminEmail) {
    const adminKey = adminEmail.replace(/\./g, '_');
    const employeesRef = ref(database, `users/${adminKey}/employees`);
    const listenerKey = `employee-list-watcher-${adminKey}`; // Unique key per admin

    // Prevent duplicate listener for employee list watcher
    this.preventDuplicateListener(listenerKey, () => {
      return onValue(
        employeesRef,
        async (snapshot) => {
          if (snapshot.exists()) {
            const currentEmployees = [];
            Object.values(snapshot.val()).forEach((employee) => {
              if (employee.email && employee.active !== false) {
                currentEmployees.push(employee.email);
              }
            });

            const existingEmployeeListeners = Array.from(this.activeListeners.keys())
              .filter((key) => key.startsWith('employee-'))
              .map((key) => {
                const parts = key.split('-');
                return parts[1]; // Extract email part
              });

            const newEmployees = currentEmployees.filter(
              (email) => !existingEmployeeListeners.includes(email.replace(/\./g, '_'))
            );

            if (newEmployees.length > 0) {
              console.log(`🆕 New employees detected: ${newEmployees.join(', ')} - refreshing sync`);
              await this.refreshSync();
            }
          }
        },
        {
          errorCallback: (error) => {
            console.error('Error in employee addition listener:', error);
          },
        }
      );
    });
  }

  cleanupListeners() {
    console.log(`🧹 Cleaning up ${this.activeListeners.size} sync listeners`);

    this.activeListeners.forEach((unsubscribe, key) => {
      try {
        if (typeof unsubscribe === 'function') {
          unsubscribe();
        }
      } catch (error) {
        console.error(`Error cleaning up listener ${key}:`, error);
      }
    });

    this.activeListeners.clear();
  }

  async refreshSync() {
    console.log('🔄 Manually refreshing global sync...');

    if (this.syncInProgress) {
      console.log('Sync refresh already in progress, skipping...');
      return;
    }

    this.cleanupListeners();
    this.isInitialized = false;
    this.syncInProgress = false;

    if (this.currentUser) {
      await this.initializeGlobalSync();
    }
  }

  ensureSyncActive() {
    if (this.currentUser && !this.isInitialized && !this.syncInProgress) {
      console.log('🔄 Ensuring sync is active after navigation...');
      this.initializeGlobalSync();
    }
  }

  getSyncStatus() {
    return {
      isInitialized: this.isInitialized,
      currentUser: this.currentUser?.email || null,
      activeListeners: this.activeListeners.size,
      syncInProgress: this.syncInProgress,
      syncPaths: this.SYNC_PATHS,
    };
  }

  async forceSyncPath(path, data, sourceUserEmail) {
    if (!this.SYNC_PATHS.includes(path)) {
      console.warn(`Path ${path} is not in sync paths`);
      return;
    }

    console.log(`🚀 Force syncing ${path} from ${sourceUserEmail} ${data === null ? '(deletion)' : ''}`);

    try {
      const sourceKey = sourceUserEmail.replace(/\./g, '_');
      const profileRef = ref(database, `users/${sourceKey}/profile`);

      return new Promise((resolve, reject) => {
        const unsubscribe = onValue(
          profileRef,
          async (snapshot) => {
            try {
              const profileData = snapshot.val();

              if (profileData && profileData.isEmployee && profileData.adminEmail) {
                const employeeEmails = await this.getEmployeeEmails(profileData.adminEmail);
                const adminKey = profileData.adminEmail.replace(/\./g, '_');

                await set(ref(database, `users/${adminKey}/${path}`), data);

                for (const employeeEmail of employeeEmails) {
                  if (employeeEmail !== sourceUserEmail) {
                    const employeePermissions = await this.getEmployeePermissions(employeeEmail);
                    const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

                    if (!employeeAllowedPaths.includes(path)) {
                      console.log(`⏭️ Skipping force sync of ${path} to ${employeeEmail} - not in allowed paths`);
                      continue;
                    }

                    const empKey = employeeEmail.replace(/\./g, '_');
                    await set(ref(database, `users/${empKey}/${path}`), data);
                  }
                }
              } else {
                const employeeEmails = await this.getEmployeeEmails(sourceUserEmail);

                for (const employeeEmail of employeeEmails) {
                  const employeePermissions = await this.getEmployeePermissions(employeeEmail);
                  const employeeAllowedPaths = this.getAllowedDataPaths(employeePermissions);

                  if (!employeeAllowedPaths.includes(path)) {
                    console.log(`⏭️ Skipping force sync of ${path} to ${employeeEmail} - not in allowed paths`);
                    continue;
                  }

                  const empKey = employeeEmail.replace(/\./g, '_');
                  await set(ref(database, `users/${empKey}/${path}`), data);
                }
              }

              console.log(`✅ Force sync completed for ${path} ${data === null ? '(deletion)' : ''}`);
              unsubscribe(); // Clean up the listener
              resolve();
            } catch (error) {
              console.error(`❌ Error in force sync for ${path}:`, error);
              unsubscribe(); // Ensure cleanup on error
              reject(error);
            }
          },
          {
            onlyOnce: true,
            errorCallback: (error) => {
              console.error(`❌ Error in force sync profile listener for ${path}:`, error);
              unsubscribe(); // Ensure cleanup on error
              reject(error);
            },
          }
        );
      });
    } catch (error) {
      console.error(`❌ Error in force sync for ${path}:`, error);
      throw error;
    }
  }
}

const globalSyncService = new GlobalSyncService();

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  window.globalSyncService = globalSyncService;
}

export default globalSyncService;